import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { PrivateAppStartupService } from './private-app-startup.service';

/**
 * Starts login on the way into the private app, before any child route's auth
 * guard runs, as the OIDC client expects. Public routes never reach it.
 */
export const privateAppStartupGuard: CanMatchFn = () => {
  inject(PrivateAppStartupService).start();

  return true;
};
